import React from 'react';
import { styled } from '@mui/material/styles';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { CheckBoxOutlineBlankOutlined } from '@mui/icons-material';

const PREFIX = 'BoxListItem';

const classes = {
  icon: `${PREFIX}-icon`,
  itemText: `${PREFIX}-itemText`,
  list: `${PREFIX}-list`,
};

const StyledListItem = styled(ListItem)(({ theme }) => ({
  [`& .${classes.icon}`]: { fontSize: 12, minWidth: 30, marginTop: 6 },
  [`& .${classes.itemText}`]: { margin: 0, padding: 0 },
  [`&.${classes.list}`]: { alignItems: 'flex-start', padding: theme.spacing(0, 1, 1, 1) },
}));

interface IProps {
  title: string;
}

export const BoxListItem = (props: IProps) => {
  return (
    <StyledListItem className={classes.list}>
      <ListItemIcon className={classes.icon}>
        <CheckBoxOutlineBlankOutlined fontSize={'inherit'} />
      </ListItemIcon>
      <ListItemText className={classes.itemText} primary={props.title} />
    </StyledListItem>
  );
};
